(function(){

G.Debug = G.Debug || {};

G.Debug.getMemoryUsedByBitmaps = getMemoryUsedByBitmaps;

G.Debug.Stats = createStatsMonitor();

return;

//

function createStatsMonitor() {

  var cleanupFunc = null;

  return {
    show: show,
    hide: hide
  };

  function show(optVerbose, optX, optY) {
    cleanup();
    var position = {
      x: optX || 0,
      y: optY || 0
    };
    var debugDrawer = createDebugDrawer();
    var statSuppliers = getStatSuppliers(debugDrawer, optVerbose);
    cleanupFunc = (function getCleanupFuncIIFE(){
      var revokeRenderWrapper = G.Utils.wrapFunction(
        Phaser.State.prototype, 'render',
        null,
        function() {
          var stage = this;
          debugDrawer.drawTextRect(
            stage.game,
            statSuppliers.map(
              function(supplier) { return supplier.getFunc(stage.game); }
            ).join('\n'),
            position.x,
            position.y
          );
        }
      );
      return cleanup;
      function cleanup() {
        revokeRenderWrapper();
        revokeRenderWrapper = null;
        for (var i = statSuppliers.length; i--;) {
          statSuppliers[i].destroy();
        }
        statSuppliers = [];
      }
    }());
  }

  /**
   * @returns Array<{ getFunc: (game: Phaser.Game) => string, destroy: () => void }>
   */
  function getStatSuppliers(debugDrawer, optVerbose) {
    var statSuppliers = [ createFPSSupplier() ];
    if (optVerbose) {
      statSuppliers = statSuppliers.concat([
        createElementsAmountSupplier(),
        createDrawCallsAmountSupplier(debugDrawer),
        createStatsSupplier(),
        createBitmapsSupplier()
      ]);
    }
    return statSuppliers;
  }

  function hide() {
    cleanup();
  }

  function cleanup() {
    cleanupFunc && cleanupFunc();
    cleanupFunc = null;
  }

  // suppliers

  function createFPSSupplier() {
    return {
      getFunc: getFPS,
      destroy: destroy
    };
    function getFPS(game) { return 'FPS: ' + game.time.fps; }
    function destroy() {}
  }

  //

  function createElementsAmountSupplier() {
    var debouncedGetElementsAmountFunc = G.AsyncUtils.debounce(getTotalChildrenCount, 1000);
    return {
      getFunc: getElementsAmount,
      destroy: destroy
    };
    function getElementsAmount(game) {
      return (
        'Elements amount: ' +
        debouncedGetElementsAmountFunc(game.state.getCurrentState().stage)
      );
    }
    function destroy() {
      debouncedGetElementsAmountFunc = null;
    }
  }

  //

  function createDrawCallsAmountSupplier(debugDrawer) {
    var drawCallsCounter = createDrawCallsCounter(debugDrawer.isDrawingDebug);
    return {
      getFunc: getDrawCallsAmount,
      destroy: destroy
    };
    function getDrawCallsAmount(game) {
      return (
        'Draw calls: ' +
        drawCallsCounter.getDrawCallsCountForLastFrame()
      );
    }
    function destroy() {
      drawCallsCounter.destroy();
      drawCallsCounter = null;
    }
  }

  //

  function createStatsSupplier() {

    var wrapperRevokers = [];

    var stats = createStatsTracker();
    statFunc(stats, Phaser.Game.prototype,  'update',          '      Total', true);
    statFunc(stats, Phaser.Game.prototype,  'updateRender',    '     Render');
    statFunc(stats, Phaser.Stage.prototype, 'preUpdate',       ' Pre update');
    statFunc(stats, Phaser.Stage.prototype, 'update',          '     update');
    statFunc(stats, Phaser.Stage.prototype, 'postUpdate',      'Post update');

    return {
      getFunc: getStats,
      destroy: destroy
    };

    function getStats(game) {
      return stats.toString();
    }

    function destroy() {
      for (var i = wrapperRevokers.length; i--;) {
        wrapperRevokers[i]();
      }
      wrapperRevokers = [];
    }

    function statFunc(statsTracker, obj, funcName, statName, optShowAsFps) {
      statsTracker.addStat(
        statName,
        optShowAsFps
          ? function(value, name) {
            return name + ' ' + value.toFixed(2) + 'ms (' + (1000 / value).toFixed(1) + ' fps)';
          }
          : undefined
      );
      var revoke = G.Utils.wrapFunction(
        obj, funcName,
        function pre()  { statsTracker.startStat(statName); },
        function post() { statsTracker.stopStat(statName);  }
      );
      wrapperRevokers.push(revoke);
    }
  }

  //

  function createBitmapsSupplier() {

    return {
      getFunc: getBitmaps,
      destroy: destroy
    };

    function getBitmaps(game) {
      return 'Bitmaps: ' + getBitmapsSize(game);
    }

    function destroy() {}

    function getBitmapsSize(game) {
      var info = getMemoryUsedByBitmaps(game);
      var assetsMb = bitmapAreaToMbString(info.assets);
      var canvasesMb = bitmapAreaToMbString(info.canvases);
      return [
        '',
        '  assets: 1024x1024 x ' + bitmapAreaRelative(info.assets, 1024)  + ' (' + assetsMb   + ')',
        '  bitmaps: 128x128  x ' + bitmapAreaRelative(info.canvases, 128) + ' (' + canvasesMb + ')',
        '  total: ' + bitmapAreaToMbString(info.assets + info.canvases)
      ].join('\n');
    }

    // tools

    function bitmapAreaToMbString(area) {
      var BYTES_PER_PIXEL = 4;
      var mbs = area * BYTES_PER_PIXEL / 1024 / 1024;;
      return mbs.toFixed(2) + 'MB';
    }

    function bitmapAreaRelative(area, reference) {
      return (area / (reference * reference)).toFixed(2);
    }
  }
}

//

function createStatsTracker() {
  var map = {}

  return {
    addStat:   addStat,
    startStat: startStat,
    stopStat:  stopStat,
    toString:  toString
  };

  function addStat(name, optCustomStringifier) {
    map[name] = {
      stat: createStat(),
      stringifier: optCustomStringifier || defaultStringifier
    };
  }
  function startStat(name) { map[name].stat.start(); }
  function stopStat(name)  { map[name].stat.stop();  }

  function defaultStringifier(value, name) {
    return name + ' ' + value.toFixed(2) + 'ms';
  }

  function toString() {
    return Object.keys(map).map(function(name) {
      var obj = map[name];
      return obj.stringifier(obj.stat.getAverageValue(), name);
    }).join('\n');
  }

  //

  function createStat() {

    var BUFFER_SIZE = 60;

    var buffer = G.StorageUtils.createRingBuffer(BUFFER_SIZE);
    var lastTimestamp;
    var depth = 0;

    return {
      start: start,
      stop: stop,
      getAverageValue: getAverageValue
    };

    function start() {
      if (depth === 0) {
        lastTimestamp = getTimestamp();
      }
      ++depth;
    }

    function stop() {
      --depth;
      if (depth === 0) {
        buffer.push(getTimestamp() - lastTimestamp);
      }
    }

    function getTimestamp() { return performance.now(); }

    function getAverageValue() {
      var bufferSize = buffer.getActualSize();
      if (bufferSize === 0) return 0;

      var average = 0;
      buffer.forEach(function(value, index) { average += value; });
      average /= bufferSize;
      return average;
    }
  }
}

// phaser tools

  function getMemoryUsedByBitmaps(game) {

    return {
      assets:   getLoadedImagesSize(game),
      canvases: getPooledCanvasesSize()
    };

    function getLoadedImagesSize(game) {
      var images = [];
      Object.keys(game.cache._cache.image).forEach(function(key) {
        var entry = game.cache._cache.image[key];
        entry.data && G.StorageUtils.addUnique(images, entry.data);
      }, 0);
      return images.reduce(function(acc, image) {
        return acc + image.naturalWidth * image.naturalHeight;
      }, 0);
    }

    function getPooledCanvasesSize() {
      var area = Phaser.CanvasPool.pool.reduce(function(acc, element) {
        var area = element.canvas.width * element.canvas.height;
        return acc + area;
      }, 0);
      return area;  
    }
  }

  function getTotalChildrenCount(parent) {
    return 1 + (
      !parent.children
        ? 0
        : parent.children.reduce((acc, curr) => acc + getTotalChildrenCount(curr), 0)
    )
  }

  function createDebugDrawer() {

    var COLOR_BACKGROUND = 'rgba(0,0,0,0.66)';
    var COLOR_TEXT       = '#00ff00';

    var OFFSET_X = 0;
    var OFFSET_Y = 15;

    var CHAR_WIDTH  = 9.5;
    var CHAR_HEIGHT = 15;
    var PADDING = 5;

    var drawingDebug = false;

    return {
      isDrawingDebug: isDrawingDebug,
      drawTextRect: drawTextRect
    };

    function isDrawingDebug() {
      return drawingDebug;
    }

    function drawTextRect(game, multilineText, x, y) {

      drawingDebug = true;

      var lines = multilineText.split('\n');
      var maxLineWidth = lines.reduce(function(max, line) {
        return Math.max(max, line.length);
      }, 0);

      game.debug.rectangle(
        {
          x: OFFSET_X + x + game.camera.x,
          y: OFFSET_Y + y + game.camera.y - CHAR_HEIGHT,
          width:  2 * PADDING + CHAR_WIDTH  * maxLineWidth,
          height: 2 * PADDING + CHAR_HEIGHT * lines.length
        },
        COLOR_BACKGROUND
      );

      lines.forEach(function(str, index) {
        game.debug.text(
          str,
          OFFSET_X + x + PADDING,
          OFFSET_Y + y + PADDING + CHAR_HEIGHT * index - 3,
          COLOR_TEXT
        );
      });

      drawingDebug = false;
    }

  }

  function createDrawCallsCounter(optIsRenderingDebugFunc) {

    var resetFunction = saveFunction(Phaser.Game.prototype, 'updateRender');
    var drawCallsFunctions = [
      saveFunction(CanvasRenderingContext2D.prototype, 'clearRect'   ),
      saveFunction(CanvasRenderingContext2D.prototype, 'drawImage'   ),
      saveFunction(CanvasRenderingContext2D.prototype, 'fill'        ),
      saveFunction(CanvasRenderingContext2D.prototype, 'stroke'      ),
      saveFunction(CanvasRenderingContext2D.prototype, 'fillRect'    ),
      saveFunction(CanvasRenderingContext2D.prototype, 'strokeRect'  ),
      saveFunction(CanvasRenderingContext2D.prototype, 'fillText'    ),
      saveFunction(CanvasRenderingContext2D.prototype, 'strokeText'  ),
      saveFunction(CanvasRenderingContext2D.prototype, 'putImageData')
    ];

    var lastDrawCallsCount = 0;
    var drawCallsCount = {
      total: 0,
      debug: 0
    };

    var wrapperRevokers = [];

    wrapFunctionTracked(
      resetFunction.object, resetFunction.funcName,
      function() {
        lastDrawCallsCount = drawCallsCount.total - drawCallsCount.debug;
        drawCallsCount.total = 0;
        drawCallsCount.debug = 0;
      }
    );

    drawCallsFunctions.forEach(function(data) {
      wrapFunctionTracked(
        data.object, data.funcName,
        function() {
          drawCallsCount.total++;
          if (optIsRenderingDebugFunc && optIsRenderingDebugFunc()) {
            drawCallsCount.debug++;
          }
        }
      );
    });

    return {
      getDrawCallsCountForLastFrame: getDrawCallsCountForLastFrame,
      destroy: destroy
    };

    function getDrawCallsCountForLastFrame() {
      return lastDrawCallsCount;
    }

    function saveFunction(object, funcName) {
      return {
        object:   object,
        funcName: funcName
      };
    }

    function destroy() {
      for (var i = wrapperRevokers.length; i--;) {
        wrapperRevokers[i]();
      }
      wrapperRevokers = [];
    }

    function wrapFunctionTracked(obj, funcName, pre, post) {
      var revoke = G.Utils.wrapFunction(obj, funcName, pre, post);
      wrapperRevokers.push(revoke);
    }
  }

}());
